import { Button, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import React from 'react';
import { track, events } from 'src/configs/amplitude';
import { currencyFormatter } from 'src/utils/translator';
import useStyles from '../styles';
const formatPercent = value => Number(value).toFixed(2);
const describeChange = _ref => {
  let priorCycleTotal = _ref.priorCycleTotal,
    currentCycleTotal = _ref.currentCycleTotal,
    variancePercent = _ref.variancePercent;
  const percent = "".concat(formatPercent(variancePercent), "%");
  if (!Number.isFinite(priorCycleTotal) || !Number.isFinite(currentCycleTotal) || priorCycleTotal === currentCycleTotal) {
    return "changed by ".concat(percent);
  }
  const direction = currentCycleTotal < priorCycleTotal ? 'decreased' : 'increased';
  return "".concat(direction, " by ").concat(percent, " (from ").concat(currencyFormatter(priorCycleTotal), " to ").concat(currencyFormatter(currentCycleTotal), ")");
};
export const VarianceReview = _ref2 => {
  let variance = _ref2.variance,
    loadFailed = _ref2.loadFailed,
    isApproved = _ref2.isApproved,
    isBusy = _ref2.isBusy,
    onReview = _ref2.onReview,
    onRetry = _ref2.onRetry;
  const classes = useStyles();
  if (isApproved) return null;
  if (loadFailed) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.warningBlock,
      role: "alert"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.warningBlockData
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, "Could not load the variance")), /*#__PURE__*/React.createElement("div", {
      className: classes.warningBlockAction
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionButtonInvert",
      onClick: () => {
        track(events.clicked('Retry Variance'), {
          page: 'Apply Billing'
        });
        onRetry();
      },
      disabled: isBusy
    }, "Retry")));
  }
  if (!(variance !== null && variance !== void 0 && variance.requiresAcknowledgement)) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.warningBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.warningBlockData
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Your allocation total has ".concat(describeChange(variance), " since the last approved regular (non-additional) cycle before this month, which is more than the ").concat(formatPercent(variance.thresholdPercent), "% threshold. Please review the allocations and check the box below.")), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: !!variance.isReviewed,
      onChange: e => onReview(e.target.checked),
      disabled: !!variance.isReviewed || isBusy,
      'custom-attribute': '700-MeterDetails'
    }),
    label: "I reviewed the allocations against the last approved regular (non-additional) cycle before this month."
  }))));
};